export const hasInternshipPermissions = ({ user }) => user.internships && user.internships.length > 0
